import { UserUpdatesSelect } from "@/components/form/user-updates-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

type UserUpdatesFieldExtraProps = {
  /** Scopes the member list to this place. */
  placeId: string;
  /** The order's assignee — always offered alongside the place members. */
  assigneeId: string;
  placeholder?: string;
};

/** **Value is a list of user ids** (`string[]`). */
export type UserUpdatesFieldProps = PickerFieldProps<
  string[],
  UserUpdatesFieldExtraProps
>;

export const UserUpdatesField = makePickerField<
  string[],
  UserUpdatesFieldExtraProps
>({
  name: "UserUpdatesField",
  control: UserUpdatesSelect,
  popout: true,
  controlProps: (props) => ({
    placeId: props.placeId,
    assigneeId: props.assigneeId,
    placeholder: props.placeholder,
  }),
});
